import { type Dayjs, extend } from "dayjs";
import utc from "dayjs/plugin/utc";

extend(utc);

// from underlying rc-picker library that we aren't importing in just for types
export type RangeValueType<T> = [start: T | null | undefined, end: T | null | undefined];
export type NoUndefinedRangeValueType<T> = [start: T | null, end: T | null];

/** A range of numeric dates, with start and end being optional.
 * Generally, if either part is undefined, the range is not considered valid. */
export type RangeOfOptionals = [number | undefined, number | undefined];

/**
 * Convert a range of Dayjs to millisecond timestamps. Any empty values result in an empty output.
 * Values returned are aligned to the start and end of a local day.
 * @param range The range (start and end) of timestamps to convert.
 * @returns The range expressed as Unix timestamps in milliseconds.
 */
export function msFromDateRange(range: RangeValueType<Dayjs>): RangeOfOptionals {
    const returnRange: RangeOfOptionals = [undefined, undefined];

    if (range[0]) {
        returnRange[0] = range[0].startOf("day").utc().valueOf();
    }

    if (range[1]) {
        returnRange[1] = range[1].endOf("day").utc().valueOf();
    }

    return returnRange;
}
